export const roles = {
  ADMIN: 'admin',
  ROOT: 'root',
  USER: 'user',
}

export const rolesIds = {
  ROOT: 0,
  ADMIN: 1,
  USER: 2,
}


export const isAdmin = role => [roles.ROOT, roles.ADMIN].includes(role)
